import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { targetService } from '../../services/targets/targetService'
import { SetTargetForm, BulkSetTargetsForm } from '../../types'
import { showSuccessToast, showErrorToast } from '../../utils/errorHandler'

// Get all bookers with their current month targets
export const useBookersWithTargets = () => {
  return useQuery({
    queryKey: ['bookers-with-targets'],
    queryFn: () => targetService.getBookersWithTargets(),
  })
}

// Get monthly performance with daily breakdown
export const useMonthlyPerformance = (month?: number, year?: number) => {
  return useQuery({
    queryKey: ['monthly-performance', month, year],
    queryFn: () => targetService.getMonthlyPerformance(month, year),
  })
}

// Set or update target for a single booker
export const useSetBookerTarget = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: SetTargetForm) => targetService.setBookerTarget(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bookers-with-targets'] })
      queryClient.invalidateQueries({ queryKey: ['monthly-performance'] })
      showSuccessToast('Target updated successfully!')
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

// Bulk update targets for multiple bookers
export const useBulkSetTargets = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: BulkSetTargetsForm) => targetService.bulkSetTargets(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bookers-with-targets'] })
      queryClient.invalidateQueries({ queryKey: ['monthly-performance'] })
      showSuccessToast('Targets updated successfully!')
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

